import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import Immutable from 'immutable'
import { ButtonToolbar, Button } from 'reactstrap'
import Content from '../../../layout/Content'
import { clearLegalTickets, getLegalTicketByDocumentNumber, getLegalTickets, postGenerateExcel } from '../../../../actions/legal/LegalTicket'
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes'
import LegalTicketForm from './LegalTicketForm'
import { tzNormalizeDate } from '../../../../utils/date'
import { INT_DATE_FORMAT } from '../../../../config/locale'
import LegalTicketTableForm from './LegalTicketTableForm'
import LegalTicketSearchByDocumentNumberForm from './LegalTicketSearchByDocumentNumberForm'
import { LEGAL_SOURCE_SYSTEM } from '../../../../config/constants'
import { getTicket } from '../../../../actions'
import { printTicket } from '../../../../utils/printers/Ticket'

const LegalTicket = ({
  breadcrumbs,
  dispatchGetLegalTickets,
  dispatchClearLegalTickets,
  legalTickets,
  loading,
  dispatchPostGenerateExcel,
  dispatchGetLegalTicketByDocumentNumber,
  dispatchGetTicket,
  ticket,
  ticketLoading
}) => {

  const [isSearchByCustomer, setIsSearchByCustomer] = useState(true);

  useEffect(() => () => dispatchClearLegalTickets(), [])

  useEffect(() => {
    const ticketJS = ticket.toJS();
  if (ticketJS && Object.keys(ticketJS).length > 0) {
    printTicket(ticketJS);
  }
  }, [ticket]);

  const searchByCustomer = (formValues) => {
    const { customer, fromDateString, toDateString } = formValues;

    const startDate = tzNormalizeDate({
      date: fromDateString,
      format: INT_DATE_FORMAT,
    });
    const endDate = tzNormalizeDate({
      date: toDateString,
      format: INT_DATE_FORMAT,
    });

    const newFormValues = {
      customerId: customer ? customer.value : null,
      startDate,
      endDate,
    }

    dispatchGetLegalTickets(newFormValues)
  }

  const searchByDocumentNumber = (formValues) => {
    const { documentSerie, documentCode } = formValues;
    dispatchGetLegalTicketByDocumentNumber({ documentSerie, documentCode });
  }

  const onSubmit = (formValues) => {
    if (isSearchByCustomer) {
      searchByCustomer(formValues);
      return
    }

    searchByDocumentNumber(formValues);
  }

  const handleTableSubmit = ({ items }) => {
    dispatchPostGenerateExcel(items)
  }

  const form = isSearchByCustomer ? (
    <LegalTicketForm onSubmit={onSubmit} loading={loading} />
  ) : (
    <LegalTicketSearchByDocumentNumberForm onSubmit={onSubmit} loading={loading} />
  );

  const handleSearchChange = () => {
    setIsSearchByCustomer(!isSearchByCustomer);
    clearLegalTickets();
  }

  const toolbar = (
    <ButtonToolbar className="pull-right">
      <div>
        <Button
          color="secondary"
          onClick={handleSearchChange}
        >
          {!isSearchByCustomer ? 'Buscar Por Cliente/Empresa' : 'Buscar por Comprobante'}
        </Button>
      </div>
    </ButtonToolbar>
  )

  const printAction = async ({ idSourceSystem }) => {   
    const system = idSourceSystem.split('-')[0];
    const ticketId = idSourceSystem.split('-')[1];
    if (system !== LEGAL_SOURCE_SYSTEM.FLIT.value) {
      return
    }
    dispatchGetTicket({ ticketId });
  }

  const content = (
    <>
      {form}
      <h3>Resultado de Búsqueda de Boletos</h3>
      <LegalTicketTableForm
        loading={loading || ticketLoading}
        legalTickets={legalTickets}
        onSubmit={handleTableSubmit}
        printAction={printAction}
      />
    </>
  )

  return (
    <Content
      title="Boletos"
      text="Éste es el módulo de Gestión de Boletos."
      breadcrumbs={breadcrumbs}
      content={content}
      toolbar={toolbar}
    />
  )
}

LegalTicket.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchGetLegalTickets: PropTypes.func.isRequired,
  dispatchClearLegalTickets: PropTypes.func.isRequired,
  legalTickets: PropTypes.instanceOf(Immutable.List).isRequired,
  loading: PropTypes.bool,
  dispatchPostGenerateExcel: PropTypes.func.isRequired,
  dispatchGetLegalTicketByDocumentNumber: PropTypes.func.isRequired,
  dispatchGetTicket: PropTypes.func.isRequired,
  ticket: PropTypes.instanceOf(Immutable.Map).isRequired,
  ticketLoading: PropTypes.bool,
};

LegalTicket.defaultProps = {
  loading: false,
  ticketLoading: false,
};

const mapStateToProps = ({ LegalUnit, ReservationUnit }) => ({
  breadcrumbs: [
    ...LegalUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Carga',
      href: '',
    },
  ],
  loading: LegalUnit.LegalTicket.getIn(['all', 'loading']),
  legalTickets: LegalUnit.LegalTicket.getIn(['all', 'content']),
  ticket: ReservationUnit.Ticket.getIn(['current', 'content']),
  ticketLoading: !ReservationUnit.Ticket.getIn(['current', 'activity']).isEmpty()
});

const mapDispatchToProps = {
  dispatchGetLegalTickets: getLegalTickets,
  dispatchClearLegalTickets: clearLegalTickets,
  dispatchPostGenerateExcel: postGenerateExcel,
  dispatchGetLegalTicketByDocumentNumber: getLegalTicketByDocumentNumber,
  dispatchGetTicket: getTicket
};

export default connect(mapStateToProps, mapDispatchToProps)(LegalTicket);

